import styled from 'styled-components';
import { Link } from 'gatsby';
import { FcMenu } from 'react-icons/fc';

export const Nav = styled.nav`
  /* background: transparent; */
  width: 100%;
  background: #fff;
  min-height: 80px;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem calc((100vw - 1300px) / 2);
  z-index: 100;
  /* position: relative; */
  transition: 0.5s ease;

  animation-duration: 0.6s;
  position: fixed;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
  @media screen and (max-width: 468px) {
    display: block;
  }
`;
export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  /* padding: 0 1rem; */
  cursor: pointer;
`;
export const Bars = styled(FcMenu)`
  display: none;
  color: #1c0824;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    cursor: pointer;
    font-size: 1.8rem;
  }
`;
export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavHeader = styled.div`
  /* font-size: 70px; */
  font-size: ${({ largeHeader }) => (largeHeader ? '60px' : '40px')};
  font-weight: ${({ largeHeader }) => (largeHeader ? '400' : '200')};
  top: 0;
  display: flex;
  align-items: center;
  margin-left: 20px;
  /* color: #0c0c0c; */
  font-family: 'WindSong', cursive;
  color: #4c006e;
  transition: 0.2s;

  @media screen and (max-width: 768px) {
    font-size: ${({ largeHeader }) => (largeHeader ? '50px' : '30px')};
    font-weight: ${({ largeHeader }) => (largeHeader ? '300' : '150')};
    align-items: flex-start;
    left: 5;
    transform: translate(20%, 10%);
    cursor: pointer;
  }
`;
export const H1 = styled.h1`
  color: #0c0c0c;
`;
export const MediaMenu = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    background: #fff;
    min-height: 150px;
    position: absolute;
    display: block;
    overflow: hidden;
    margin-top: 400;
    right: 60px;
    top: 60px;
    z-index: 999;
    padding-top: 10px;
    padding-bottom: 10px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  }
`;
export const MediaSubMenu = styled.div`
  float: none;
  display: flex;
  text-align: left;
  text-decoration: none;
  padding: 12px 16px;
  color: #1c0824;
  -webkit-transition: background 0.2s ease-in-out;
  transition: background 0.2s ease-in-out;
  -ms-transition: background 0.2s ease-in-out;
  -webkit-transition: color 0.2s;
  transition: color 0.2s ease-in-out;
  -ms-transition: color 0.2s ease-in-out;
  -webkit-transition: border 0.2s;
  transition: border 0.2s ease-in-out;
  -ms-transition: border 0.2s ease-in-out;
  &:hover {
    -webkit-transition: background 0.2s ease-in-out;
    transition: background 0.2s ease-in-out;
    -ms-transition: background 0.2s ease-in-out;
    -webkit-transition: color 0.2s;
    transition: color 0.2s ease-in-out;
    -ms-transition: color 0.2s ease-in-out;
    -webkit-transition: border 0.2s;
    transition: border 0.2s ease-in-out;
    -ms-transition: border 0.2s ease-in-out;

    background: #f6f4ff;
    border-bottom: 2px solid #7f00ff;
    color: #4c006e;
  }
  @media screen and (max-width: 768px) {
    float: none;
    display: flex !important;
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 0px;
    margin-right: 0px;
    text-decoration: none;
    border: none;
    min-width: 100px;
    min-height: 20px;
    align-items: center;
    justify-content: center;
    &:hover {
      background: #f1f1f1;
      border-bottom: 0px dashed transparent;

      border-left: 2px solid #7f00ff;
      color: #3a0054;
    }
  }
`;
